import template from './list-panel.html'
import * as XLSX from 'xlsx'

export let listPanel = {
	template    : template,
	controllerAs: 'vm',
	controller  : [ 'ReviewSrv', 'uiGridConstants', '$rootScope', '$interval', '$cookies', '$state',
		'GlobalConfig', 'Validations', 'uiGridExporterConstants', 'GeneralSettingsSrv', '$scope', '$window',
		function listPanelCtrl (ReviewSrv, uiGridConstants, $rootScope, $interval, $cookies, $state,
			GlobalConfig, Validations, uiGridExporterConstants, GeneralSettingsSrv, $scope, $window) {
			const vm = this

			$rootScope.fullscreenClass = 'background-planning'

			const currentStage = $state.current.tag
			const stagesIds = GlobalConfig.workplanIdStages
			const currentRoleId = JSON.parse($cookies.get('hasRoleId'))

			const inConsultant = Validations.inConsultant(currentRoleId)
			const inAdminConsultantUnit = Validations.inAdminConsultantUnit(currentRoleId)
			const isWorkplanCommittee = Validations.isWorkplanCommittee(currentRoleId)
			const isCommittee = Validations.isCommitteeRole(currentRoleId)
			const isCommitteeAdmin = Validations.isCommitteeAdmin(currentRoleId)

			const inReview = Validations.inReview(currentStage)
			const inApproval = Validations.inApproval(currentStage)
			const inExecution = Validations.inExecution(currentStage)
			const inReviewExecution = Validations.inReviewExecution(currentStage)
			const inEvaluation = Validations.inEvaluation(currentStage)
			const validUser = Validations.validUser(currentRoleId, currentStage)

			vm.generalIndicatorsLabel = 'Planes de trabajo'
			vm.mainLabel = $state.current.data.label
			vm.classAction = ''
			vm.isConsultantOrAdmin = false
			vm.isConsultantOrAdminUnit = false
			vm.committeesList = []

			vm.loadIndicatorData = loadIndicatorData
			vm.singleFilter = singleFilter
			vm.exportGrid = exportGrid
			vm.changeWorkplansList = changeWorkplansList
			$scope.changeWorkplansList = changeWorkplansList
			let header = {
				idRol      : currentRoleId,
				idEvaluator: JSON.parse($cookies.get('currentUser')).id,
				idStage    : null,
			}

			vm.indicators = []

			vm.gridPanel = {
				enableFiltering                : true,
				exporterOlderExcelCompatibility: true,
				columnDefs                     : [
					{
						name            : 'Nombre del profesor',
						displayName     : 'Nombre del profesor',
						field           : 'teacherName',
						width           : '35  %',
						enableGridMenu  : false,
						enableFiltering : true,
						enableHiding    : false,
						enablePinning   : false,
						enableColumnMenu: false,
						enableSorting   : false,
					}, {
						name            : 'Plan de trabajo asignado',
						displayName     : 'Plan de trabajo asignado',
						field           : 'workplanName',
						width           : '38%',
						enableGridMenu  : false,
						enableFiltering : true,
						enableHiding    : false,
						enablePinning   : false,
						enableColumnMenu: false,
						enableSorting   : false,
					}, {
						name            : 'Estado',
						displayName     : 'Estado',
						field           : 'stageName',
						width           : '15%',
						enableGridMenu  : false,
						enableFiltering : true,
						enableHiding    : false,
						enablePinning   : false,
						enableColumnMenu: false,
						enableSorting   : false,
					}, {
						name            : 'Acciones',
						displayName     : 'Acciones',
						field           : 'actionText',
						width           : '12%',
						enableGridMenu  : false,
						enableFiltering : false,
						enableHiding    : false,
						enablePinning   : false,
						enableColumnMenu: false,
						enableSorting   : false,
						headerCellClass : 'column-center',
						cellClass       : vm.classAction,
						cellTemplate    : '<panel-router data="{teacherId: row.entity.teacherId, workplanId: row.entity.workplanId, name: row.entity.teacherName, stage: row.entity.stageId}" action="row.entity.actionText"></panel-router>',
					},
				],
				onRegisterApi: (gridApi) => {
					vm.gridApi = gridApi
					vm.gridApi.grid.registerRowsProcessor(vm.singleFilter, 100)
					$interval(function () {
						vm.gridApi.core.handleWindowResize()
					}, 500, 10)
				},
			}

			vm.gridCommittee = {
				enableFiltering: true,
				columnDefs     : [
					{
						name            : 'Comité',
						displayName     : 'Comité',
						field           : 'commitee.ds_name',
						width           : '100%',
						enableGridMenu  : false,
						enableFiltering : true,
						enableHiding    : false,
						enablePinning   : false,
						enableColumnMenu: false,
						enableSorting   : false,
						cellTemplate    : '<div class="ui-grid-cell-contents over-auto-normal"><a ng-click="grid.appScope.changeWorkplansList(row.entity.teachers, row.entity.commitee.ds_name)">{{row.entity.commitee.ds_name}}</a></div>',
					},
				],
				onRegisterApi: (gridApi) => {
					vm.gridApiCommittee = gridApi
					$interval(function () {
						vm.gridApiCommittee.core.handleWindowResize()
					}, 500, 10)
				},
			}

			//init
			vm.$onInit = () => {
				if (!validUser) {
					$state.go('app.unauthorized')
				}

				vm.classAction = inReviewExecution ? 'column-center' : 'column-left'
				header.idStage = setHeader()

				//console.log('header.idStage',header.idStage)
				if (vm.isConsultantOrAdmin) {
					getWorkplansList({})
				} else if (vm.isConsultantOrAdminUnit) {
					let obj = { idUser: JSON.parse($cookies.get('currentUser')).id }

					getWorkplansList(obj)
				} else if (isWorkplanCommittee || isCommittee || isCommitteeAdmin) {
					vm.showCommittees = true
					getCommittersByUserId()
				} else {
					vm.mainLabel = 'Etapa de ' + vm.mainLabel
					getReviewList(header)
				}
			}

			function setHeader () {
				switch (true) {

				case inReview:
					return stagesIds.review
				case inApproval:
					return stagesIds.approval
				case inExecution:
					return stagesIds.execution
				case inReviewExecution:
					return stagesIds.reviewExecution
				case inEvaluation:
					return stagesIds.evaluation
				case inConsultant:
					vm.isConsultantOrAdmin = true

					return stagesIds.consultant
				case inAdminConsultantUnit:
					vm.isConsultantOrAdminUnit = true

					return stagesIds.adminConsultantUnit
				
				}
			}

			function getReviewList (header) {
				vm.isLoading = true
				ReviewSrv.getPanelWorkplans.post(header).$promise.then((dataReturn) => {
					if (dataReturn.status) {
						vm.totalData = dataReturn.data
						setIndicatorData()
						vm.isLoading = false
					}
				}).catch((err) => {
					console.log(err)
				})
			}

			function getWorkplansList (header) {
				ReviewSrv.getAllWorkplanList.post(header).$promise.then((dataReturn) => {
					if (dataReturn.status) {
						vm.gridPanel.data = dataReturn.data
						//setIndicatorData()
					}
				}).catch((err) => {
					console.log(err)
				})
			}

			function getCommittersByUserId () {
				GeneralSettingsSrv.getCommittersByUserId.get({ idUser: header.idEvaluator }).$promise.then((dataReturn) => {
					if (dataReturn.status) {
						vm.committeesList = dataReturn.data
						vm.gridCommittee.data = vm.committeesList
					}
				}).catch((err) => {
					console.log(err)
				})
			}

			function changeWorkplansList (list, committeeName) {
				vm.committeeName = committeeName || null
				vm.gridPanel.data = list.map((a) => {
					a.actionText = 'ver'

					return a
				})
			}

			function setIndicatorData() {
				for (var i = 0; i < vm.totalData.length; i++) {
					if (i == 0) {
						vm.gridPanel.data = vm.totalData[i].data
						vm.totalData[i].selected = true
					} else vm.totalData[i].selected = false

					vm.indicators.push(vm.totalData[i])
				}
			}

			function loadIndicatorData(indicator) {
				vm.indicators.forEach((ind) => {ind.selected = false})
				vm.gridPanel.data = indicator.data
				indicator.selected = true
			}

			vm.workPlanFilter = ''

			function singleFilter (renderableRows) {
				var matcher = new RegExp(vm.workPlanFilter, 'i')

				renderableRows.forEach(function (row) {
					var match = false;

					[ 'teacherName' ].forEach(function(field) {
						if (row.entity[field] && row.entity[field].match(matcher)) {
							match = true
						}
					})

					if (!match) {
						row.visible = false
					}
				})

				return renderableRows
			}
  
			function exportGrid() {
				const fileName = `planes_de_trabajo`
				const wb = XLSX.utils.book_new()

				const table = [
					[
						'Nombre del profesor',
						'Cédula',
						'Plan de trabajo asignado',
						'Etapa',
						'Unidad Académica',
					],
				]

				for (let i in vm.gridPanel.data) {
					table.push([
						vm.gridPanel.data[i]['teacherName'],
						vm.gridPanel.data[i]['identification'],
						vm.gridPanel.data[i]['workplanName'],
						vm.gridPanel.data[i]['stageName'],
						vm.gridPanel.data[i]['academicUnit'],
					])
				}

				const ws = XLSX.utils.aoa_to_sheet(table)

				XLSX.utils.book_append_sheet(wb, ws, fileName)

				const wbbuf = XLSX.write(wb, {
					bookType: 'xlsx',
					mimeType:
						'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
					type: 'base64',
				})

				const a = document.createElement('a')

				a.href =
					'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,' +
					encodeURI(wbbuf)
				a.target = '_blank'
				a.download = `${fileName}.xlsx`
				document.body.appendChild(a)
				a.click()
				document.body.removeChild(a)
			}
		},
	] }



// WEBPACK FOOTER //
// ./src/app/u-faculty/components/activities-review/list-panel.js